import Axios from '@/common/require'
export default{
  GET_STATISTICS(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/statistics/index',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/statistics/actions.js